export default class Venue {
  constructor(API) {
    this.api = API;
  }
  /*
  {
    customerID: 'validString',
    cityID: 'validString',
    id: 'validString',
    name: 'validString',
    address: {
      street1: 'validString',
      street2: 'validString',
      postalCode: 'validString',
      province: 'validString',
    },
    comments: 'optionalValidString',
    createdBy: 'any?',
    updatedBy: 'any?',
    updatedOn: 'any?',
    createdOn: 'any?',
    transactionID: 'any?',
  }
  */
  async createVenue(venueObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/venue/new';
    req.body = venueObj;
    return await req.exec();
  }
  async updateVenue(venueObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = '/venue/' + venueObj.id;
    req.body = venueObj;
    return await req.exec();
  }
  async deleteVenue(venueID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/venue/' + venueID;
    return await req.exec();
  }
  async getVenue(venueID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/venue/' + venueID;
    return await req.exec();
  }
  async getAllVenues() {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/venues/';
    return await req.exec();
  }
}
